import { render, staticRenderFns } from "./BackhaulProvider.vue?vue&type=template&id=661d34f7"
import script from "./BackhaulProvider.vue?vue&type=script&lang=js"
export * from "./BackhaulProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports